// Hand-maintained AIS positions, keyed by hostname. There is no AIS feed into
// this app, so these are copied from weco-dashboard's
// src/components/Items/LiveData/AIS.js and must be kept in step with it --
// see issue #2 for a live feed.
export const AIS_POSITIONS = {
  denshi: {
    name: 'CC-262 NLD POWERBUOY',
    mmsi: 992441232,
    latitude: 38.44158,
    longitude: -9.08772,
    reported: '2026-09-13 19:02:00 UTC',
  },
};
